import { useCallback, useMemo } from 'react';
import './pagination.scss';

type PaginationType = {
  totalPages: number,
  onPageChange: (itemNum: number) => void,
  activePageNum?: number,
  setActivePageNum?: (page: number) => void,
}

/**
 * @param {number} totalPageNum 合計ページ数
 * @param {(itemNum: number) => void} onPageChange ページ変更時処理
 * @param {number} activePage 表示中ページ番号
 * @param {(page: number) => void} setActivePage 表示中ページ番号の更新処理
 */
export const Pagination = (props: PaginationType) => {

  const { totalPages, onPageChange, activePageNum: _activePageNum, setActivePageNum } = props;
  const displayLength = 5;
  const arr = new Array(totalPages > displayLength ? displayLength : totalPages).fill(null);

  // - Memo -
  const activePageNum = useMemo(()=>{
    // string型で判定されてfalseなる箇所があったためその阻止のための対応
    return Number(_activePageNum);
  },[_activePageNum]);

  // -- 表示ページ番号の内の最初のアイテム番号 --
  const firstItemNum = useMemo(() => {
    if (activePageNum > totalPages || activePageNum < 1) {
      console.error('存在しないページ番号を参照しようとしています。', { activePageNum });
    }
    if (totalPages <= displayLength) return 1;
    const half = Math.floor(displayLength / 2);
    if (activePageNum <= half) return 1;
    if (activePageNum >= totalPages - half) return totalPages - displayLength + 1;
    return activePageNum - half;
  }, [activePageNum, totalPages]);

  const goToPage = useCallback((page: number) => {
    if (page < 1 || page > totalPages) return;
    setActivePageNum?.(page);
    onPageChange(page);
  }, [totalPages]);

  return (
    <ul className="pagination">
      {/* pagination__prev, pagination__next デザインなしにつき仮置き */}
      {totalPages >= displayLength &&
      activePageNum > 1 && (
        <li className="pagination__prev" onClick={() => goToPage(activePageNum - 1)}>
          {'<'}
        </li>
      )}
      {arr.map((v, i) => {
        const itemNum = firstItemNum + i;
        return (
          <li
            key={`pagination-item_${itemNum}`}
            className={`pagination__item ${itemNum === activePageNum ? 'active' : ''} ${!i ? 'first_item' : ''}`}
            onClick={() => goToPage(itemNum)}
          >
            {itemNum}
          </li>
        )
      })}
      {totalPages >= displayLength &&
      activePageNum < totalPages && (
        <li className="pagination__next" onClick={() => goToPage(activePageNum + 1)}>
          {'>'}
        </li>
      )}
    </ul>
  )
}
